module.exports = __webpack_public_path__ + "img/down.6b839010.svg";